import { render } from "./DesignBento.vue?vue&type=template&id=a0875a56&scoped=true"
import script from "./DesignBento.vue?vue&type=script&lang=js"
export * from "./DesignBento.vue?vue&type=script&lang=js"

import "./DesignBento.vue?vue&type=style&index=0&id=a0875a56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0875a56"]])

export default __exports__